import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiEndPoints } from "../../../helpers/constants";
import { notify, notifyAPIMessages } from "../../../helpers/commonFunctions";
import axios from "axios";
import { authHeaders } from "../../../helpers/axios";
import { BASE_URL } from "../../../config";

export const fetchAdmins = createAsyncThunk("admins/fetchAdmins", async () => {
  return await apiRequest("/api/v1/admins");
});
export const reqToAdminLogin = createAsyncThunk(
  "reqToAdminLogin",
  async ({ data, onSuccess, onFailure }) => {
    try {
      const response = await axios.post(BASE_URL + apiEndPoints.signIn, data);
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return error;
    }
  }
);

export const reqToGetDashbaordDeatils = createAsyncThunk(
  "reqToGetDashbaordDeatils",
  async ({ data, onSuccess, onFailure }) => {
    try {
      const response = await axios.get(
        BASE_URL + apiEndPoints.getDashboardData,
        authHeaders()
      );
      onSuccess(response);
      return response;
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure(error);
      return error;
    }
  }
);

export const reqToGetRecentTenants = createAsyncThunk(
  "reqToGetRecentTenants",
  async ({ data, onSuccess, onFailure }) => {
    try {
      let url = BASE_URL + apiEndPoints.getDashboardData;

      // add filter (week/month/year)
      if (data?.date) {
        url += `?date=${data.date}`;
      }

      const response = await axios.get(url, authHeaders());
      onSuccess && onSuccess(response);
      return response.data; // return clean data
    } catch (error) {
      notify(error?.response?.data?.message || "Network Error", "error");
      onFailure && onFailure(error);
      throw error;
    }
  }
);

const adminsSlice = createSlice({
  name: "admins",
  initialState: {
    items: [],
    dashboard: [],
    recentTenants: [],
    loading: false,
    error: null,

    // Auth state
    authLoading: false,
    authError: null,
    user: null,
    token: null,
  },
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
    },
    setToken(state, action) {
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Admins
      .addCase(fetchAdmins.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // GET DASHBAORD
    builder.addCase(reqToGetDashbaordDeatils.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetDashbaordDeatils.fulfilled, (state, action) => {
      state.loader = false;
      state.dashboard = action.payload?.data?.data || null;
    });
    builder.addCase(reqToGetDashbaordDeatils.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload);
    });

    // Login
    builder.addCase(reqToAdminLogin.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToAdminLogin.fulfilled, (state, action) => {
      state.loader = false;
      state.user = action.payload?.data?.data || null;
      localStorage.setItem("token", action.payload?.data?.data?.token);
    });
    builder.addCase(reqToAdminLogin.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload);
    });

    // GET DASHBAORD
    builder.addCase(reqToGetRecentTenants.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(reqToGetRecentTenants.fulfilled, (state, action) => {
      state.loader = false;
      state.recentTenants = action.payload?.data?.getNewTenant?.rows || null;
    });
    builder.addCase(reqToGetRecentTenants.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
      notifyAPIMessages(action.payload);
    });
  },
});
export const { logout } = adminsSlice.actions;
export default adminsSlice.reducer;
